export const ResetState = (state, defaultState) => {
  Object.assign(state, defaultState())
}



// WEBPACK FOOTER //
// ./src/state/utils/index.js